import { css, keyframes } from "styled-components";
import { LightboxFrame } from "../../components/LightboxFrame";
import { LightboxClose } from "../../components/LightboxClose";
const fadeInKeyframes = keyframes `
  from { opacity: 0;}
  to { opacity: 1; }
`;
export const riotProductSkin = (chroma, paletteTokens) => css `
  animation: ${fadeInKeyframes} 0.3s ease-in;

  h1 {
    ${chroma.typography.display5};
  }

  ${chroma.typography.body2};
  color: ${paletteTokens.accents1};
  background-color: rgb(255 255 255 / 70%);
  z-index: ${chroma.dimensions.lightboxZIndex};

  ${LightboxFrame} {
    animation: ${fadeInKeyframes} 0.5s ease-in;
  }

  ${LightboxClose} {
    background-color: ${paletteTokens.ctabg1};
    border-radius: 2px;

    & > span {
      background-color: ${paletteTokens.ctatext1};
    }
  }
`;
//# sourceMappingURL=index.js.map